import React from 'react';
import { OptionProps } from 'react-select';
import { GenericDropdownOption } from '../../../../../App.types';
import Image from '../../../../../ui/Image/Image';
import styles from './RelatedArtistOption.module.css';

export type RelatedArtistOptionType = GenericDropdownOption<number> & { image: string | null };
export type RelatedArtistOptionProps = OptionProps<RelatedArtistOptionType, true>;

const RelatedArtistOption = (props: RelatedArtistOptionProps) => {
    return (
        <div ref={props.innerRef} {...props.innerProps} className={styles.container}>
            <Image src={props.data.image} alt={props.label} className={styles.image} />
            <span className={styles.label}>{props.label}</span>
        </div>
    );
};

export default RelatedArtistOption;
